import z from "zod";

import { PageData, PageMeta } from "./pagination";
import { ApiResp, ErrorResp } from "./response";

// Response status codes enum
export enum ResponseStatus {
  SUCCESS = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  UNPROCESSABLE_ENTITY = 422,
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503
}

// Response codes enum
export enum ResponseCode {
  SUCCESS = "SUCCESS",
  CREATED = "CREATED",
  UPDATED = "UPDATED",
  DELETED = "DELETED",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  NOT_FOUND = "NOT_FOUND",
  UNAUTHORIZED = "UNAUTHORIZED",
  FORBIDDEN = "FORBIDDEN",
  CONFLICT = "CONFLICT",
  TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE"
}

// Helper functions for creating responses
export const createSuccessResp = <T>(data: T, message?: string, code?: ResponseCode): ApiResp<T> => ({
  success: true,
  status: ResponseStatus.SUCCESS,
  code: code || ResponseCode.SUCCESS,
  message: message || "Operation completed successfully",
  data,
  timestamp: new Date().toISOString()
});

export const createErrorResponse = (
  error: string,
  status: ResponseStatus = ResponseStatus.BAD_REQUEST,
  code?: ResponseCode,
  details?: Record<string, any>
): ErrorResp => ({
  success: false,
  status,
  code: code || ResponseCode.VALIDATION_ERROR,
  message: error,
  error,
  details,
  timestamp: new Date().toISOString()
});

export const createPageData = <T>(data: T[], meta: PageMeta): PageData<T> => ({
  data,
  meta
});

export const SearchRedirectSchema = z.object({
  redirectUrl: z.string().url().optional()
});
export type SearchRedirect = z.infer<typeof SearchRedirectSchema>;
